import React from "react"

import ContentfulCodeSnippet from "./components/ContentfulCodeSnippet"
import ContentfulExploreHighlightBlock from "./components/ContentfulExploreHighlightBlock"
import ContentfulFaq from "./components/ContentfulFaq"
import ContentfulFeaturedProductList from "./components/ContentfulFeaturedProductList"
// import ContentfulHeroTwoColumnText from "./components/ContentfulHeroTwoColumnText"
import ContentfulHeroTwoUp from "./components/ContentfulHeroTwoUp"
import ContentfulHighlightCard from "./components/ContentfulHighlightCard"
import ContentfulImageCard from "./components/ContentfulImageCard"
import ContentfulImageGrid from "./components/ContentfulImageGrid"
import ContentfulImageSlider from "./components/ContentfulImageSlider"
import ContentfulLegalContent from "./components/ContentfulLegalContent"
import ContentfulLinkSlider from "./components/ContentfulLinkSlider"
import ContentfulMedia from "./components/ContentfulMedia"
import ContentfulMediaCarousel from "./components/ContentfulMediaCarousel"
// import ContentfulOneImageFeaturesCta from "./components/ContentfulOneImageFeaturesCta"
import ContentfulProductSlider from "./components/ContentfulProductSlider"
import ContentfulPromoBlock from "./components/ContentfulPromoBlock"
import ContentfulReflowBlock from "./components/ContentfulReflowBlock"
import ContentfulTextBlock from "./components/ContentfulTextBlock"
import ContentfulTextSlider from "./components/ContentfulTextSlider"
// import ContentfulTwoImageCta from "./components/ContentfulTwoImageCta"
import ContentfulTwoImageFeaturesCta from "./components/ContentfulTwoImageFeaturesCta"
import { GraphQLUnionType } from "./types"

const components = {
  ContentfulCodeSnippet,
  ContentfulExploreHighlightBlock,
  ContentfulFaq,
  ContentfulFeaturedProductList,
  // ContentfulHeroTwoColumnText,
  ContentfulHeroTwoUp,
  ContentfulHighlightCard,
  ContentfulImageCard,
  ContentfulImageGrid,
  ContentfulImageSlider,
  ContentfulLegalContent,
  ContentfulLinkSlider,
  ContentfulMedia,
  ContentfulMediaCarousel,
  ContentfulProductSlider,
  // ContentfulOneImageFeaturesCta,
  ContentfulPromoBlock,
  ContentfulReflowBlock,
  ContentfulTextBlock,
  ContentfulTextSlider,
  // ContentfulTwoImageCta,
  ContentfulTwoImageFeaturesCta,
}

const renderContent = (
  content: GraphQLUnionType | GraphQLUnionType[] | null
): React.ReactNode => {
  // Preconditions
  if (content == null) {
    console.warn("renderContent, received undefined content", content)
    return null
  }

  if (Array.isArray(content)) {
    return content.map(renderContent)
  }

  // Render component
  const { __typename, id, ...rest } = content

  const Component = components[__typename]
  if (!Component) {
    console.warn("Component not found for", __typename, rest)
    return null
  }

  return <Component id={id} key={id} renderContent={renderContent} {...rest} />
}

interface ContentfulContentProps {
  content: any[]
}

const Component: React.FC<ContentfulContentProps> = ({ content }) => (
  <>{content ? content.map(renderContent) : null}</>
)

export default Component
